/* ====================================================================================================================
 * CHERİE — Kemer AOV kampanyası / şerit görünürlüğü
 * --------------------------------------------------------------------------------------------------------------------
 * Sorumluluğu tek şey: kemer seçim şeridi ne zaman açık, ne zaman kapalı olacağına karar vermek.
 * Sepete ekleme ve yeniden render Prestige'in kendi kodudur; burada tekrar edilmez.
 *
 * KURALLAR
 *   1. Şerit sunucudan `hidden` gelir. Bu oturumda kapatılmadıysa JS onu açar.
 *      (Sunucudan açık gelseydi, "Şimdi değil" dedikten sonra her sepet yenilemesinde geri gelirdi.)
 *   2. "Şimdi değil" yalnız o modu (`bag` / `gift`) kapatır. Sepet sonradan hediye eşiğini
 *      geçerse `gift` ayrı bir mod olduğu için şerit bir kez daha açılır — bu istenen davranıştır.
 *   3. Şerit kapalıyken yerinde "Kemer teklifini göster" satırı kalır. Kemer henüz sepette
 *      olmadığı için üstte bar da yoktur; geri dönüş yolu budur.
 *   4. Kampanya kemeri sepete eklenince şerit render edilmez, yerine bar gelir — JS'e iş düşmez.
 * ================================================================================================================== */

(() => {
  const DISMISSED_KEY = 'cherie-belt:dismissed-modes';

  const readDismissed = () => {
    try {
      return new Set(JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || '[]'));
    } catch {
      return new Set();
    }
  };

  const writeDismissed = (set) => {
    try {
      sessionStorage.setItem(DISMISSED_KEY, JSON.stringify([...set]));
    } catch {
      /* gizli sekme — davranış bozulmasın, sadece hafıza kaybolur */
    }
  };

  /** Şerit ile onun kapalı hâlini tek karardan, birbirini dışlayacak biçimde günceller. */
  const applyVisibility = (picker, visible) => {
    picker.hidden = !visible;

    const reopenRow = document.querySelector(`[data-belt-reopen-row][data-belt-target="${picker.id}"]`);
    if (reopenRow) reopenRow.hidden = visible;
  };

  /** Sayfadaki her şerit için oturum hafızasına göre doğru görünürlüğü uygular. */
  const syncAll = () => {
    const dismissed = readDismissed();

    document.querySelectorAll('[data-belt-picker]').forEach((picker) => {
      applyVisibility(picker, !dismissed.has(picker.dataset.beltMode));
    });
  };

  /* ------------------------------------------------------------------------------------------------------------
   * Olay bağlantıları — tıklamalar delege edilir, çünkü sepet çekmecesi sürekli yeniden render edilir.
   * ---------------------------------------------------------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    // "Şimdi değil" → bu modu bu oturum için kapat.
    const dismissButton = event.target.closest('[data-belt-dismiss]');
    if (dismissButton) {
      const picker = dismissButton.closest('[data-belt-picker]');
      if (!picker) return;

      const dismissed = readDismissed();
      dismissed.add(picker.dataset.beltMode);
      writeDismissed(dismissed);
      applyVisibility(picker, false);
      return;
    }

    // "Kemer teklifini göster" → kapatılmış şeridi geri getir ve görünür alana kaydır.
    const reopenButton = event.target.closest('[data-belt-reopen]');
    if (reopenButton) {
      const row = reopenButton.closest('[data-belt-reopen-row]');
      const picker = row && document.getElementById(row.dataset.beltTarget);
      if (!picker) return;

      const dismissed = readDismissed();
      dismissed.delete(picker.dataset.beltMode);
      writeDismissed(dismissed);
      applyVisibility(picker, true);
      picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

  // Sepet çekmecesi her yeniden render edildiğinde şerit yeni HTML ile gelir; kararı tekrar uygula.
  document.documentElement.addEventListener('cart-drawer:refreshed', syncAll);

  // Sepet sayfası ve ilk yükleme.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
